import { emailRegex } from "./emailRegex";

const isEmailValid = (email) => (emailRegex.test(email));

export default isEmailValid;